"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.step = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const lmsModel_1 = require("../../lms/lmsModel");
require("./stepNames");
const stepNames_1 = require("./stepNames");
const scormApi = require("../../lms/ScormApi");
let scormTemplate = require("../scorm.tmpl.htm");
class ScormRunner {
    constructor($wizard, $scormFrame, checklistDocId) {
        this.m_$wizard = $wizard;
        this.m_$scormFrame = $scormFrame;
        this.m_checklistDocId = checklistDocId;
    }
    runScorm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let startInfoUrl = Utilities_1.synUtil.getWSUrl("LmsScormStartInfo") + that.m_checklistDocId.toString();
            let scormStartInfo = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: startInfoUrl,
            });
            this.m_api = new scormApi.ScormApi(that.m_checklistDocId.toString(), false, scormStartInfo.userId, scormStartInfo.userName, true, "normal", scormStartInfo.launchData, scormStartInfo.scoData);
            window.API = this.m_api;
            window.TdScormFinished = that.scormFinished.bind(that);
            let url = $.address.baseURL() + "/ScormRuntime/" + scormStartInfo.lessonId + "/" + scormStartInfo.startPath;
            that.m_$scormFrame.focus();
            Utilities_1.synUtil.beginAjaxProgress();
            setTimeout(() => { that.m_$scormFrame.attr("src", url).focus(); }, 250);
        });
    }
    set ignoreFurtherCommits(val) {
        if (this.m_api)
            this.m_api.ignoreFurtherCommits = val;
    }
    scormFinished() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ignoreFurtherCommits = true;
            if (this.m_$wizard.synWizard("getCurrentStepName") === stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.briefing]) {
                let lessonJSON = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("LmsGetLessonForVisitorObject") + this.m_checklistDocId.toString(),
                });
                let lesson = yield lmsModel_1.LMSLesson.fromJSON(lessonJSON);
                if (lesson && lesson.Completion === 2) {
                    let globalStorage = this.m_$wizard.synWizard("getGlobalStorage");
                    globalStorage["briefingFinished"] = true;
                    yield this.m_$wizard.synWizard("notifyGlobalStorageChanged");
                    this.m_$wizard.synWizard("nextStep");
                }
                else
                    yield this.runScorm();
            }
        });
    }
    waitForScormCommit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.m_api)
                yield this.m_api.waitForLastCommit();
        });
    }
}
exports.step = {
    name: stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.briefing],
    nextPossibleSteps: [stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.questionnaire], stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end]],
    canReRun: ($this) => {
        let globalStorage = $this.synWizard("getGlobalStorage");
        if (globalStorage["finished"] === true || globalStorage["briefingFinished"] === true)
            return false;
        else
            return true;
    },
    run: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _a;
        $this.trigger("synWizardPauseIdleTimeout");
        let $contentDiv = $this.synWizard("getStepContentDiv").addClass("scorm");
        let pathStorage = $this.synWizard("getPathStorage");
        let globalStorage = $this.synWizard("getGlobalStorage");
        let checklistDocId = pathStorage["checklistDocId"];
        let lesson = yield lmsModel_1.LMSLesson.fromJSON(pathStorage["lesson"]);
        if (lesson.IsSCORM) {
            window.synUtil_endAjaxProgress = Utilities_1.synUtil.endAjaxProgress;
            $contentDiv.html(kendo.template(scormTemplate));
            let scormRunner = new ScormRunner($this, $contentDiv.find("iframe.scormFrame"), checklistDocId);
            globalStorage.scormRunner = scormRunner;
            $this.synWizard("notifyGlobalStorageChanged");
            scormRunner.runScorm();
        }
        else {
            let lessonId = (_a = lesson.LessonInstance) === null || _a === void 0 ? void 0 : _a.id.value;
            try {
                let contentDownloadable = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("ContentInstanceDownloadable") + lessonId,
                });
                if (contentDownloadable["downloadable"] === true) {
                    let url = Utilities_1.synUtil.getWSUrl("ContentInstanceDownload") + lessonId;
                    $contentDiv.html("<iframe src='" + url + "' frameborder='0'></iframe>");
                    $this.synWizard("enableNextButton");
                }
                else {
                    $.error("visitorManagement: No downloadable content for id " + lessonId);
                }
            }
            catch (error) {
                "Method not implemented.";
            }
        }
    }),
    persist: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let globalStorage = $this.synWizard("getGlobalStorage");
        let scormRunner = globalStorage.scormRunner;
        if (scormRunner)
            yield scormRunner.waitForScormCommit();
        $this.trigger("synWizardUnpauseIdleTimeout");
    }),
    cleanup: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let globalStorage = $this.synWizard("getGlobalStorage");
        let scormRunner = globalStorage.scormRunner;
        if (scormRunner)
            scormRunner.ignoreFurtherCommits = true;
        $this.trigger("synWizardUnpauseIdleTimeout");
    }),
    getNextStepName: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _b;
        let pathStorage = $this.synWizard("getPathStorage");
        let lesson = yield lmsModel_1.LMSLesson.fromJSON(pathStorage["lesson"]);
        let lessonId = (_b = lesson.LessonInstance) === null || _b === void 0 ? void 0 : _b.id.value;
        let questionnaireInstance = yield Utilities_1.synUtil.getAJAXDataAsync({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("ChecklistCreateQuestionnaire"),
            requestData: {
                lessionid: lessonId,
                historyobjectid: lessonId,
            },
        });
        if (!$.isEmptyObject(questionnaireInstance)) {
            pathStorage["questionnaire"] = questionnaireInstance;
            return stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.questionnaire];
        }
        else {
            return stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end];
        }
    }),
    getNextStepNamePrediction: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let pathStorage = $this.synWizard("getPathStorage");
        let lesson = yield lmsModel_1.LMSLesson.fromJSON(pathStorage["lesson"]);
        if (lesson) {
            return yield exports.step.getNextStepName($this);
        }
        else {
            return undefined;
        }
    }),
};
